import { Injectable } from "@angular/core";
import { Service } from "src/app/core/jsonapi/service";
import { CostLine } from "../_types/cost-line";
import { Observable } from "rxjs";
import { ParamsBuilder } from "src/app/core/jsonapi/params/params-builder";
@Injectable({
  providedIn: 'root',
})

export class CostsLinesService extends Service<CostLine> {
  public override type = 'costsLines';
  public override url = 'common/costLines';

  
  public getProfits(params: any): Observable<any> {
      let url = this.getAPIUrl()+"/costLines/profits/";   
      url += "?"+ params;
      
      return this.http.get<any>(url);
  }
  
}
